import { render, staticRenderFns } from "./accounting-report-payment-table.vue?vue&type=template&id=d2832b74&scoped=true&"
import script from "./accounting-report-payment-table.vue?vue&type=script&lang=ts&"
export * from "./accounting-report-payment-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2832b74",
  null
  
)

export default component.exports